import { ColumnDef } from '@tanstack/react-table';
import { SortableHeader, TruncatedCell } from '@/components';
import { formatTableDate } from '../../utils/formatTableDate';
import { LabResultDataFlatRow } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';

export const createLabResultsColumns =
  (): ColumnDef<LabResultDataFlatRow>[] => [
    {
      accessorKey: 'labPanel',
      header: 'Lab Panel',
      cell: ({ row }) =>
        row.original.labPanel ? (
          <TruncatedCell text={row.original.labPanel} className="font-medium" />
        ) : (
          'No data available'
        ),
    },
    {
      accessorKey: 'labTest',
      header: 'Lab Test',
      cell: ({ row }) =>
        row.original.labTest ? (
          <TruncatedCell text={row.original.labTest} className="font-medium" />
        ) : (
          ''
        ),
    },
    {
      accessorKey: 'value',
      header: 'Value',
      cell: ({ row }) => row.original.value || '',
    },
    {
      accessorKey: 'units',
      header: 'Units',
      cell: ({ row }) => row.original.units || '-',
    },
    {
      accessorKey: 'dateOfStudy',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Date of Study</SortableHeader>
      ),
      cell: ({ row }) => formatTableDate(row.original.dateOfStudy),
    },
    {
      id: 'sourceType',
      accessorFn: (row) => row.sourceTypes,
      header: 'Sources',
      cell: ({ row }) => {
        const sourceTypes = row.original.sourceTypes ?? [];
        if (sourceTypes.length === 0) {
          return row.original.labTest ? 'No data available' : '';
        }
        return sourceTypes.join(', ');
      },
    },
    {
      id: 'actions',
      enableSorting: false,
      header: '',
      cell: ({ row }) => {
        const firstSourceType = row.original.sourceTypes[0];
        const hasRow = !!row.original.labTest;
        return (
          <div className="flex items-center justify-end">
            {hasRow ? (
              <PatientDocumentViewButton
                disabled={!firstSourceType}
                documentKey={{
                  source: DocumentSource.MEDICAL_DATA,
                  type: DocumentType.LAB_RESULTS,
                  labPanelId: row.original.panelId,
                  sourceType: firstSourceType,
                  name: row.original.labPanel || row.original.labTest,
                }}
              />
            ) : null}
          </div>
        );
      },
    },
  ];
